var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2225 11.6364H12.6V5.74545C12.8683 5.68485 13.1192 5.60291 13.3525 5.49964C13.5858 5.39636 13.8017 5.26012 14 5.09091V11.6364C14 12.0364 13.8628 12.3789 13.5884 12.664C13.314 12.9491 12.9845 13.0914 12.6 13.0909H2.8L0 16V2.90909C0 2.50909 0.1372 2.16655 0.4116 1.88145C0.686 1.59636 1.01547 1.45406 1.4 1.45455H8.47C8.42333 1.69697 8.4 1.93939 8.4 2.18182C8.4 2.42424 8.42333 2.66667 8.47 2.90909H1.4V12.4909L2.2225 11.6364ZM2.8 10.1818H8.4V8.72727H2.8V10.1818ZM2.8 8H11.2V6.54545H2.8V8ZM2.8 5.81818H11.2V5.74545C10.7683 5.64849 10.3745 5.4817 10.0184 5.24509C9.66233 5.00848 9.3562 4.71467 9.1 4.36364H2.8V5.81818ZM11.9 4.36364C11.3167 4.36364 10.8208 4.15152 10.4125 3.72727C10.0042 3.30303 9.8 2.78788 9.8 2.18182C9.8 1.57576 10.0042 1.06061 10.4125 0.636364C10.8208 0.212121 11.3167 0 11.9 0C12.4833 0 12.9792 0.212121 13.3875 0.636364C13.7958 1.06061 14 1.57576 14 2.18182C14 2.78788 13.7958 3.30303 13.3875 3.72727C12.9792 4.15152 12.4833 4.36364 11.9 4.36364Z",
    fill: "#3F6AC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.85c28a77d2f5c71fadfaa7a2eb94e00b.svg";
export { ForwardRef as ReactComponent };